import styled from "styled-components";
import { Link } from "react-router-dom";
import { CreatorNotificationState } from "../../Utils/pushNotifications";
import { ctaGradient } from "../../Components/sharedModalStyles";

export const Account = styled.div`
  width: 1200px;
  max-width: 90%;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: calc(4.5rem + env(safe-area-inset-bottom));
  }

  h1 {
    margin: 4rem 0;
    font-size: 2rem;
    font-weight: 500;

    @media screen and (max-width: 600px) {
      margin: 2rem 0;
      font-size: 1.8rem;
    }
  }
`;

export const AccountLinkWrapper = styled.div`
  display: flex;
  width: calc(100% - 136px);
  justify-content: center;
  flex-direction: column;
  margin: auto;
  gap: 2rem;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const AccountLinkBox = styled(Link)`
  order: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgb(255, 255, 255, 0.5);

  h3 {
    font-size: 1.6rem;
    color: white;
    font-weight: 500;

    @media screen and (max-width: 600px) {
      font-size: 1.3rem;
      font-weight: 400;
    }
  }

  svg {
    color: white;
    font-size: 1.7rem;
  }
`;

export const NotificationCard = styled.section`
  order: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 1.15rem 1.25rem;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.055);

  @media screen and (max-width: 650px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const NotificationIdentity = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  min-width: 0;
`;

export const NotificationIcon = styled.div<{ $enabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 42px;
  height: 42px;
  color: #ffffff;
  border-radius: 12px;
  background: ${({ $enabled }) =>
    $enabled ? ctaGradient : "rgba(255, 255, 255, 0.1)"};
`;

export const NotificationTitle = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 650;
  line-height: 1.35;
`;

const statusColor = (state: CreatorNotificationState): string => {
  if (state === "enabled") return "#34d399";
  if (state === "blocked") return "#fca5a5";
  return "rgba(255, 255, 255, 0.58)";
};

export const NotificationStatus = styled.span<{
  $state: CreatorNotificationState;
}>`
  padding: 0.18rem 0.48rem;
  color: ${({ $state }) => statusColor($state)};
  border: 1px solid ${({ $state }) => statusColor($state)};
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 650;
  line-height: 1;
`;

export const NotificationDescription = styled.p`
  margin: 0.35rem 0 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.86rem;
  line-height: 1.45;
`;

export const NotificationNote = styled.p`
  margin: 0.3rem 0 0;
  color: rgba(255, 255, 255, 0.45);
  font-size: 0.74rem;
  line-height: 1.4;
`;

export const NotificationButton = styled.button`
  flex: none;
  min-width: 108px;
  min-height: 40px;
  padding: 0.55rem 1rem;
  color: #ffffff;
  border: 0;
  border-radius: 10px;
  background: ${ctaGradient};
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.48;
  }

  @media screen and (max-width: 650px) {
    width: 100%;
  }
`;
